var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-drawer",
    {
      attrs: {
        title: _vm.title,
        width: 800,
        placement: "right",
        closable: false,
        visible: _vm.visible,
      },
      on: { close: _vm.close },
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules },
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "title",
                    label: "标题",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入标题" },
                    model: {
                      value: _vm.model.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "title", $$v)
                      },
                      expression: "model.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "content",
                    label: "内容",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入内容" },
                    model: {
                      value: _vm.model.content,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "content", $$v)
                      },
                      expression: "model.content",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "imgUrl",
                    label: "图片地址",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入图片地址" },
                    model: {
                      value: _vm.model.imgUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "imgUrl", $$v)
                      },
                      expression: "model.imgUrl",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "status",
                    label: "审核状态",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "status", $$v)
                      },
                      expression: "model.status",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "drawer-bootom-button" },
        [
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleOk } },
            [_vm._v("确定")]
          ),
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleCancel } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }